import { CART_INFO, BOOKING_STEP, SET_DATA_BY_STEP } from '../Actions';
const initialState = {
  cart: {},
  bookingStep: 0, // refer to constants file variable DSSteps (currently 4 steps)
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CART_INFO:
      return {
        ...state,
        cart: action.payload,
      };
    case BOOKING_STEP:
      return {
        ...state,
        bookingStep: action.payload,
      };
    case SET_DATA_BY_STEP:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
